/**
 * Before the BS player software supported caching assets on demand it would
 * query an endpoint for a list of assets it should download independent of
 * the JavaScript layer.
 *
 * Therefore, if an older player is being used, we can assume the assets are
 * most likely already cached, and we can resolve these functions
 * accordingly.
 *
 * Players earlier than 2.1.0.7 require this mixin.
 * @mixin BSLegacyVideoAssetCacheMixin
 * @todo write description
 */
var BSLegacyVideoAssetCacheMixin = function () {
    var self = this;

    /**
     * @method _legacyCacheVideoAsset
     * @return {Promise.<(true)>}
     * @memberOf BSLegacyVideoAssetCacheMixin
     * @todo write description
     */
    this._legacyCacheVideoAsset = function (assetUuid) {
        self._logWarning(
            'On demand asset caching not supported, assuming asset (' +
                assetUuid +
                ') is already cached.'
        );
        return Promise.resolve(true);
    };

    /**
     * @method _legacyGetVideoPath
     * @return {Promise.<string>}
     * @memberOf BSLegacyVideoAssetCacheMixin
     * @todo write description
     */
    this._legacyGetVideoPath = function (assetUuid) {
        return Promise.resolve('file:///' + assetUuid);
    };

    /**
     * @method _legacyIsCachedAsset
     * @return {Promise.<(true)>}
     * @memberOf BSLegacyVideoAssetCacheMixin
     * @todo write description
     */
    // eslint-disable-next-line no-unused-vars
    this._legacyIsCachedAsset = function (assetUuid) {
        return Promise.resolve(true);
    };

    return this;
};

export { BSLegacyVideoAssetCacheMixin };
